import React from 'react';
import Icon from '../../../components/AppIcon';

const EventDetails = ({ event }) => {
  return (
    <div className="bg-[var(--color-card)] rounded-xl p-6 lg:p-8 space-y-8">
      <div>
        <h2 className="text-2xl font-bold text-[var(--color-foreground)] mb-4">About This Event</h2>
        <p className="text-[var(--color-muted-foreground)] leading-relaxed whitespace-pre-line">
          {event?.fullDescription}
        </p>
      </div>
      <div className="border-t border-[var(--color-border)] pt-8">
        <h3 className="text-xl font-bold text-[var(--color-foreground)] mb-4">What You'll Do</h3>
        <ul className="space-y-3">
          {event?.activities?.map((activity, index) => (
            <li key={index} className="flex items-start gap-3">
              <div className="w-6 h-6 rounded-full bg-[var(--color-primary)]/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                <Icon name="Check" size={16} color="var(--color-primary)" />
              </div>
              <span className="text-[var(--color-foreground)]">{activity}</span>
            </li>
          ))}
        </ul>
      </div>
      <div className="border-t border-[var(--color-border)] pt-8">
        <h3 className="text-xl font-bold text-[var(--color-foreground)] mb-4">What to Bring</h3>
        <div className="grid sm:grid-cols-2 gap-3">
          {event?.whatToBring?.map((item, index) => (
            <div key={index} className="flex items-center gap-3 bg-[var(--color-muted)] rounded-lg p-3">
              <Icon name="Package" size={20} color="var(--color-primary)" />
              <span className="text-[var(--color-foreground)]">{item}</span>
            </div>
          ))}
        </div>
      </div>
      <div className="border-t border-[var(--color-border)] pt-8">
        <h3 className="text-xl font-bold text-[var(--color-foreground)] mb-4">Requirements</h3>
        <div className="space-y-3">
          {event?.requirements?.map((requirement, index) => (
            <div key={index} className="flex items-start gap-3 bg-[var(--color-accent)]/10 rounded-lg p-4">
              <Icon name="AlertCircle" size={20} color="var(--color-accent)" className="flex-shrink-0 mt-0.5" />
              <span className="text-[var(--color-foreground)]">{requirement}</span>
            </div>
          ))}
        </div>
      </div>
      <div className="border-t border-[var(--color-border)] pt-8">
        <h3 className="text-xl font-bold text-[var(--color-foreground)] mb-4">Skills You'll Develop</h3>
        <div className="flex flex-wrap gap-2">
          {event?.skillsDeveloped?.map((skill, index) => (
            <span 
              key={index}
              className="px-4 py-2 bg-[var(--color-secondary)]/10 text-[var(--color-secondary)] rounded-full text-sm font-medium"
            >
              {skill}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EventDetails;